import { NavLink } from "react-router-dom";

/**
 * The admin area's title and its submenu.
 *
 * Two pages, not a top-level nav item each: the header strip is what every
 * signed-in person navigates by, and administration is one person's job on
 * one part of the product. Adding "Evaluations" beside "Engagements" would
 * put a page most users may not open into everybody's chrome.
 *
 * `NavLink` rather than state, so each page keeps its own URL — an evaluation
 * is a thing you send somebody a link to.
 */
const TABS = [
  { to: "/admin", label: "People & activity", end: true },
  { to: "/admin/evaluations", label: "Evaluations", end: false },
  { to: "/admin/memory", label: "Memory", end: false },
  { to: "/admin/mail", label: "Mail", end: false },
];

export function AdminTabs() {
  return (
    <div>
      {/* Title, then sections — the run page's order. The tabs used to sit
          above a heading that repeated the selected tab's name. */}
      <h1 className="text-lg font-semibold">Administration</h1>
      <nav className="mt-3 flex gap-1 overflow-x-auto border-b border-line" aria-label="Administration">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              // The run page's tabs, so a section switch has one look.
              `-mb-px shrink-0 border-b-2 px-3 py-2 text-sm transition-colors ${
                isActive
                  ? "border-accent font-medium text-ink"
                  : "border-transparent text-ink-2 hover:text-ink"
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
